export default __webpack_public_path__ + "static/media/step2.bd6ce5a9.webp";